import {createLayout} from '../util/struct_array';

export default createLayout([
    {name: 'a_index', type: 'Int16', components: 1}
]);
